//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { VideosLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableBody";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
//import IconButton from "@material-ui/core/IconButton";
import CustomSelect from "components/Select/Select.jsx";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//spiffy
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";
import VideoEditor from "components/VideoEditor/VideoEditor.jsx";


//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class VideosList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      filtered: [],
      typeFilter: "all",
      quarterFilter: "all"
    }

    this.videoAdded = this.videoAdded.bind(this);
    this.videoUpdated = this.videoUpdated.bind(this);
  }

  componentDidMount() {
    this.refreshVideos();
  }

  videoAdded(video) {
    var videos = this.state.videos;
    videos.push(video);
    this.setState({videos: videos});
    this.props.onVideosLoaded(videos);
  }

  videoUpdated(video) {
    var videos = this.state.videos;
    for(var i = 0; i < videos.length; i++) {
      if(videos[i].id === video.id) {
        videos[i] = video;
        break;
      }
    }
    this.setState({videos: videos});
    this.props.onVideosLoaded(videos);
  }

  deleteVideo(video) {
    
    db.deleteVideo(video.id).then(() => {

      var videos = this.state.videos;
      for(var i = 0; i < videos.length; i++) {
        if(videos[i].id === video.id) {
          videos.splice(i,1);
          break;
        }
      }
      this.setState({videos: videos});
    });
  }

  refreshVideos() {

    if (this.props.user.authenticated) {
      
      db.getVideos(this.props.org.id).then(snapshot => {

        var videos = [];
        snapshot.forEach((doc) => {
          
          var video = doc.data();
          video.id = doc.id;
          if(!video.Photos)
              video.Photos = [];
          videos.push(video);
        });
        
        this.props.onVideosLoaded(videos);
        this.setState({videos:videos, filtered: videos});
      });
    }
  }

  getDay(value) {
    if (value === 1)
      return "M";
    else if (value === 2)
      return "T";
    else if (value === 3)
      return "W";
    else if (value === 4)
      return "Th";
    else if (value === 5)
      return "F";
    else 
      return "";
  }

  filterVideos(type, quarter) {

    var videos = this.state.videos;
    var filtered = [];

    for(var i = 0; i < videos.length; i++) {
      if(videos[i].Type === type || type === 'all') {
        if(videos[i].Quarter === quarter || quarter === 'all')
          filtered.push(videos[i]);
      }
    }

    this.setState({filtered: filtered, typeFilter: type, quarterFilter: quarter})
  }

  showType() {
    if(this.state.typeFilter === 'all')
      return "table-cell";
    else
      return "none";
  }

  showDay() {
    if(this.state.typeFilter === 'Announcement' || this.state.typeFilter === 'all')
      return "table-cell";
    else
      return "none";
  }

  showGrades() {
    if(this.state.typeFilter === 'Insight' || this.state.typeFilter === 'all')
      return "table-cell";
    else
      return "none";
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("app.allthingseq.com/videos");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Videos</h4>
                  <p className={classes.cardCategoryWhite}>
                    Videos setup here can be assigned to lessons.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Video"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                      >
                      <VideoEditor onNew={this.videoAdded}
                       video={{
                          Name: "",
                          Description: "",
                          Photos: [],
                          Type: "Insight",
                          orgId: this.props.org.id
                        }} 
                      />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomSelect
                    labelText="Type"
                    value={this.state.typeFilter}
                    inputProps={{
                        placeholder: "Type"
                    }}
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={(e) => this.filterVideos(e.target.value, this.state.quarterFilter)}
                    options={[ {key:"all", label:"All"}, {key:"Announcement", label:"Announcement" }, { key:"Insight", label:"Insight" }, { key:"Other", label:"Other" } ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomSelect
                    labelText="Quarter"
                    value={this.state.quarterFilter}
                    inputProps={{
                        placeholder: "Quarter"
                    }}
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={(e) => this.filterVideos(this.state.typeFilter, e.target.value)}
                    options={[ {key:"all", label:"All"}, {key:1, label:"Q1" }, { key:2, label:"Q2" }, { key:3, label:"Q3" }, { key:4, label:"Q4" } ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    
                </GridItem>
              </GridContainer>
              <GridItem xs={12} sm={12}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{width:"34px", padding:"3px"}}>

                      </TableCell>
                      <TableCell style={{width:"34px", padding:"3px"}}>
                        Quarter
                      </TableCell>
                      <TableCell style={{width:"34px", padding:"3px"}}>
                        Week
                      </TableCell>
                      <TableCell style={{padding:"3px", display:this.showDay()}}>
                        Day
                      </TableCell>
                      <TableCell style={{display:this.showGrades()}}>
                        Grade(s)
                      </TableCell>
                      <TableCell style={{display:this.showType()}}>
                        Type
                      </TableCell>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell style={{width:"34px", padding:"3px"}}>
                        
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.filtered.map(value => (
                      <TableRow key={value.id} className={classes.tableRow}>
                        <TableCell className={classes.tableActions} style={{width:"34px", padding:"3px"}}>
                          <Tooltip
                            id="tooltip-top"
                            title="Edit Video"
                            placement="top"
                            classes={{ tooltip: classes.tooltip }}
                          >
                          <VideoEditor video={value} onChange={this.videoUpdated} />
                          </Tooltip>
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{width:"34px", padding:"3px", textAlign:"center"}}>
                          {value.Quarter}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{width:"34px", padding:"3px", textAlign:"center"}}>
                          {value.Week}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"3px", textAlign:"center", display:this.showDay()}}>
                          {this.getDay(value.Day)}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{display:this.showGrades()}}>
                          {value.GradeLevel}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{display:this.showType()}}>
                          {value.Type}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {value.Name}
                        </TableCell>
                        <TableCell className={classes.tableActions} style={{width:"34px", padding:"3px", textAlign:"center"}}>
                        <Tooltip id="tooltip-top-start" title="Delete Video" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this video? This action cannot be undone. Note: this does not delete the source video (e.g. in Wistia)." confirmed={() => this.deleteVideo(value)} />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </GridItem>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onVideosLoaded: VideosLoaded }, dispatch);  
}

VideosList = connect(mapStateToProps, mapDispatchToProps)(VideosList);
export default withStyles(styles)(VideosList);



// WEBPACK FOOTER //
// ./src/views/VideosList/VideosList.jsx